<template lang="pug">
    AlsoKnownEditCard(v-model="alsoKnown" :createMode="true" @changedAlsoKnown="onChanged")
</template>

<script>
import {country, badCharsRegex} from "../../config.json";
import AlsoKnownEditCard from "./AlsoKnownEditCard";

const badChars = new RegExp(badCharsRegex, "g");

export default {
    components: {AlsoKnownEditCard},
    data() {
        return {
            alsoKnown: {},
            isChanged: false
        };
    },
    watch: {
      "alsoKnown.name_system"(name_system) {
        let prefix = "bbmri-eric:akiID:AT_";
        this.alsoKnown.id = prefix + ((name_system||"")+(this.alsoKnown.pid||"")+(this.alsoKnown.url||"")).replace(badChars, "");
      },
      "alsoKnown.pid"(pid) {
        let prefix = "bbmri-eric:akiID:AT_";
        this.alsoKnown.id = prefix + ((this.alsoKnown.name_system||"")+(pid||"")+(this.alsoKnown.url||"")).replace(badChars, "");
      },
      "alsoKnown.url"(url) {
        let prefix = "bbmri-eric:akiID:AT_";
        this.alsoKnown.id = prefix + ((this.alsoKnown.name_system||"")+(this.alsoKnown.pid||"")+(url||"")).replace(badChars, "");
      }

    },
    created() {
        Object.assign(this.alsoKnown, this.$route.query);
    },
  methods: {
    onChanged(isChanged) {
      this.isChanged = isChanged;
    }
  }
}
</script>
